import axios from 'axios';
import fetch from 'isomorphic-fetch';

const URL = "https://api.dinhviso.com.vn/";

export function readUsers(query) {
    return fetch(URL + 'user/' + query).then(response => response.json());
}

export function postCreateUser(user) {
    return axios({
        method: 'post',
        url: URL + 'user/create',
        data: {
            "login": user.login,
            "password": user.password,
            "mail": user.mail,
            "admin": user.admin,
            "firstname": user.firstname,
            "lastname": user.lastname,
            "projectId": user.projectId,
        }
    });
}

export function postUpdateUser(user) {
    return axios({
        method: 'post',
        url: URL + 'user/update',
        data: user
    });
}

// export function postReadUser() {
//     return axios.get(URL + 'user/read');
// }

export function postDeleteUser(userId) {
    return axios({
        method: 'get',
        url: URL + 'user/delete/' + userId,
    });
}

export function postLogin(user) {
    return axios({
        method: 'post',
        url: URL + 'auth/login',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        data: {
            "login": user.login,
            "password": user.password,
        }
    });
}

export function getTechLocation(data) {
    return fetch(`https://smartbike.vn/gapi/v1.3/vehicle`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Auth-Token': 'SfSCFu0SQZUSOjP16DrwiBpk0ktK6TqK',
        },
        body: JSON.stringify(data)
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            return {
                status: response.status,
                message: response.statusText
            };
        }
    });
}


// WEBPACK FOOTER //
// ./src/services/users.js